import { fa_danthuoc_hinhanh } from '../../models/response/y-te/fa_danthuoc';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_DAN_THUOC_HINHANH_PATH = 'danthuoc-hinhanh';

class DanThuocHinhAnhApi extends BaseCRUDApi<fa_danthuoc_hinhanh> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	SelectAllView() {
		return apiClient.get(`${API_DAN_THUOC_HINHANH_PATH}/select-all`);
	}
	SelectByDanThuoc(fa_danthuoc_id: number) {
		return apiClient.get(`${API_DAN_THUOC_HINHANH_PATH}/dan-thuoc/${fa_danthuoc_id}`);
	}
}
export const danThuocHinhAnhApi = new DanThuocHinhAnhApi(API_DAN_THUOC_HINHANH_PATH);
